import { InfoBadge, InfoBadgeTypes, Space, SubText } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useGlobalSearchListItemMetadata } from './useGlobalSearchListItemMetadata'
import { type GlobalSearchResultTypeEnum } from '../../../../../../value-objects/enums'
import { type GlobalSearchItemMetadata } from '../../../../../../value-objects/GlobalSearchItemMetadata'
import { GlobalSearchListItemStatusLabel } from '../GlobalSearchListItemStatusLabel'

interface IGlobalSearchListItemMetadataProps {
  type: GlobalSearchResultTypeEnum
  metadata: GlobalSearchItemMetadata
}

export const GlobalSearchListItemMetadata = ({
  type,
  metadata,
}: IGlobalSearchListItemMetadataProps) => {
  const intl = useProcurifyIntl()
  const formatSubTextLabel = useGlobalSearchListItemMetadata()

  const status = 'status' in metadata ? metadata.status : null
  const isPreferredVendor =
    'isPreferredVendor' in metadata && metadata.isPreferredVendor
  const subTextLabel = formatSubTextLabel(type, metadata)

  if (!status && !isPreferredVendor && !subTextLabel) {
    return null
  }

  return (
    <Space direction='horizontal' size='small' align='center'>
      {status && (
        <GlobalSearchListItemStatusLabel resultType={type} status={status} />
      )}
      {isPreferredVendor && (
        <InfoBadge
          type={InfoBadgeTypes.LOW_PRIORITY}
          text={intl.formatMessage(messages.preferredVendorLabel)}
          fontSize={12}
          size='small'
        />
      )}
      {subTextLabel && (
        <SubText noWrap textEllipsis color='textSecondary'>
          {subTextLabel}
        </SubText>
      )}
    </Space>
  )
}
